import { render, staticRenderFns } from "./MailTemplates2.vue?vue&type=template&id=31c53c88&scoped=true&"
import script from "./MailTemplates2.vue?vue&type=script&lang=js&"
export * from "./MailTemplates2.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplates2.vue?vue&type=style&index=0&id=31c53c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c53c88",
  null
  
)

export default component.exports